const e=async(e,t,n,r)=>{let{data:i}=await e.put(`/apps/${t}/terms/${n}`,r);return i};export{e as updateTerms};
//# sourceMappingURL=update-terms.mjs.map